/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react';
import { Badge, Card, Row, Col, Table } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import Input from './common/Input';
import { Eye, Trash } from 'react-bootstrap-icons';
import { CoreContext } from '../context/core-context';
import { AuthContext } from '../context/auth-context';
import { Link } from 'react-router-dom';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const Clients = (props) => {

    const coreContext = useContext(CoreContext);
    const authContext = useContext(AuthContext);

    const { register, errors } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onBlur',
    });

    const [filter, setFilter] = useState('');
    const [category, setCategory] = useState('');
    const [organization, setOrganization] = useState('');

    const [filterOptions] = useState([
        { name: 'All Applicants', value: '' },
        { name: 'Fee Paid', value: 'fee-paid' },
        { name: 'Fee Not Paid', value: 'fee-not-paid' },
        { name: 'Payment Confirmed', value: 'fee-confirmed' },
        { name: 'Payment Not Confirmed', value: 'fee-not-confirmed' },
        { name: 'Certificate Submitted', value: 'certificate-submitted' },
        { name: 'Certificate Not Submitted', value: 'certificate-not-submitted' },
        { name: 'Certificate Approved', value: 'certificate-approved' },
        { name: 'Certificate Not Approved', value: 'certificate-not-approved' }
    ]);

    const [sRoleOptions] = useState(coreContext.applicantCategories);

    const fetchCategory = (id) => {
        const v = sRoleOptions.filter(obj => obj.value == id);
        if (v[0]) return v[0].name;
        return 'Alumni';
    }

    const fetchClients = () => {
        if (authContext.item.smst_designation === 'Admin' || authContext.item.smst_designation === 'Moderator')
            coreContext.fetchClients(authContext.ownerId);
    }

    useEffect(fetchClients, []);

    const changeFilter = (fil) => {
        setFilter(fil);
        let fClients = [];
        if (fil === '') fClients = coreContext.clients;
        else if (fil === 'fee-paid') {
            fClients = coreContext.clients.filter(cc => cc.smst_payment_done === 'yes');
        } else if (fil === 'fee-not-paid') {
            fClients = coreContext.clients.filter(cc => cc.smst_payment_done === 'no');
        } else if (fil === 'fee-confirmed') {
            fClients = coreContext.clients.filter(cc => cc.smst_booking_confirmed === 'yes');
        } else if (fil === 'fee-not-confirmed') {
            fClients = coreContext.clients.filter(cc => cc.smst_booking_confirmed === 'no');
        } else if (fil === 'certificate-submitted') {
            fClients = coreContext.clients.filter(cc => cc.smst_abstract_uploaded === 'yes');
        } else if (fil === 'certificate-not-submitted') {
            fClients = coreContext.clients.filter(cc => cc.smst_abstract_uploaded === 'no');
        } else if (fil === 'certificate-approved') {
            fClients = coreContext.clients.filter(cc => cc.smst_abstract_accepted === 'yes');
        } else if (fil === 'certificate-not-approved') {
            fClients = coreContext.clients.filter(cc => cc.smst_abstract_accepted === 'no');
        }
        coreContext.setFilteredClients(fClients);
    }

    const changeSRole = (fil) => {
        setCategory(fil);
        let fClients = [];
        if (fil === '') fClients = coreContext.clients;
        else fClients = coreContext.clients.filter(cc => cc.smst_category === fil);
        coreContext.setFilteredClients(fClients);
    }

    const changeOrganizationFilter = (fil) => {
        setOrganization(fil);
        let fClients = [];
        if (fil === '') fClients = coreContext.clients;
        else {
            fClients = coreContext.clients.filter(cc => 
                (cc.smst_organization && cc.smst_organization.toLowerCase().includes(fil.toLowerCase())) || 
                (cc.item_name && cc.item_name.toLowerCase().includes(fil.toLowerCase())) ||
                (cc.item_email && cc.item_email.toLowerCase().includes(fil.toLowerCase()))
            );
        }
        coreContext.setFilteredClients(fClients);
    }

    const showDeleteWarning = (cl) => {
        // eslint-disable-next-line no-restricted-globals
        if (confirm('This applicant will be removed permanently, do you still want to delete ?')) {
            coreContext.deleteClient(cl, authContext.ownerId);
        }
    }

    const renderClients = () => {
        if (coreContext.filteredClients && coreContext.filteredClients.length > 0) {
            return coreContext.filteredClients.map((client, index) => {
                const isConfirmed = client.smst_booking_confirmed === 'yes';

                return (
                    <tr key={client.id || ++index}>
                        <td className="text-muted small">{index + 1}</td>
                        <td>
                            <strong>{client.item_name}</strong>
                            <div className="text-muted small">{client.item_email}</div>
                        </td>
                        <td>{client.smst_organization || '-'}</td>
                        <td>
                            <Badge bg="secondary" className="px-2 py-1">
                                {fetchCategory(client.smst_category)}
                            </Badge>
                        </td>
                        <td>
                            {isConfirmed ? (
                                <Badge bg="success" className="px-2 py-1">Confirmed</Badge>
                            ) : (
                                <Badge bg="warning" className="text-dark px-2 py-1">Pending</Badge>
                            )}
                        </td>
                        <td className="text-end">
                            <div className="d-flex justify-content-end gap-1">
                                <Link 
                                    className="btn btn-outline-primary btn-sm py-1 px-2" 
                                    to={`/applicant/${client.id}`} 
                                    title="Manage Applicant"
                                >
                                    <Eye size="14" /> Manage
                                </Link>
                                <button 
                                    type="button"
                                    className="btn btn-outline-danger btn-sm py-1 px-2" 
                                    onClick={() => showDeleteWarning(client.id)} 
                                    title="Delete Applicant"
                                >
                                    <Trash size="14" />
                                </button>
                            </div>
                        </td>
                    </tr>
                );
            });
        } else {
            return (
                <tr>
                    <td colSpan="6" className="text-center text-muted py-4">
                        No applicants found matching the selected filter criteria.
                    </td>
                </tr>
            );
        }
    }

    return (
        <div className="dashboard-container pb-4">
            <Card className="shadow-sm">
                <Card.Header className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div className="d-flex align-items-center gap-2">
                        <span style={{ fontSize: '1.2rem', fontWeight: 700 }}>👥 Applicants Directory</span>
                        {coreContext.filteredClients && (
                            <Badge bg="primary" className="px-2 py-1">
                                {coreContext.filteredClients.length} Members
                            </Badge>
                        )}
                    </div>
                    <div>
                        <ReactHTMLTableToExcel
                            id="applicant-table-xls-button"
                            className="btn btn-outline-success btn-sm font-weight-bold"
                            table="applicantTable"
                            filename="Swabhiman_Applicants_List"
                            sheet="Applicants"
                            buttonText="📥 Export to Excel" 
                        />
                    </div>
                </Card.Header>

                <Card.Body className="bg-light border-bottom p-3">
                    <Row className="g-2 align-items-end">
                        <Col md={3} sm={6}>
                            <Input 
                                label='Filter Status' 
                                register={register} 
                                name='filter' 
                                elementType='select' 
                                options={filterOptions} 
                                onChange={(e) => changeFilter(e.target.value)} 
                            />
                        </Col>
                        <Col md={3} sm={6}>
                            <Input 
                                label='Category' 
                                register={register} 
                                name='category' 
                                elementType='select' 
                                options={sRoleOptions} 
                                onChange={(e) => changeSRole(e.target.value)} 
                            />
                        </Col>
                        <Col md={6}>
                            <Input 
                                label='Search by Name / Email / JNV' 
                                name='organization' 
                                minLength={2} 
                                maxLength={55} 
                                register={register} 
                                errors={errors} 
                                elementType='text' 
                                placeholder='Type to search...' 
                                onChange={(e) => changeOrganizationFilter(e.target.value)} 
                            />
                        </Col>
                    </Row>
                </Card.Body>

                <Card.Body className="p-0 table-responsive">
                    <Table hover striped className="mb-0 align-middle" id='applicantTable'>
                        <thead className="table-light">
                            <tr>
                                <th style={{ width: '50px' }}>#</th>
                                <th>Name & Email</th>
                                <th>Navodaya / Institute</th>
                                <th>Category</th>
                                <th>Payment Status</th>
                                <th style={{ width: '160px' }} className="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderClients()}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </div>
    );
}

export { Clients };